export function isPathActive(pathname: string, path: string): boolean {
    return pathname === path || pathname.startsWith(`${path}/`)
}
